

module.exports = __webpack_require__.stylable.create(
    "Tagline4187661336",
    {"classes":{"root":"Tagline4187661336__root","tagline":"Tagline4187661336__tagline"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Tagline4187661336",
    null
);
